import * as React from 'react';
import { EcsterPayCheckout } from './ecster';
import { EcsterConfig } from '../../mrCapTypes';
import { className, formatNumber } from '../../util';
import * as mrCap from '../../mrCapTypes';
import * as api from '../../api/booking';

interface PaymentProps {
  paymentOnSiteText: string;
  totalPrice: number;
  totalDiscountPrice?: number;
  ecsterConfig: EcsterConfig;
  bookingId: string;
  paymentSuccess: () => void;
  financing: boolean;
  booking: mrCap.BookingRequest;
  setBookingOk: (value: boolean) => void;
  onlyProducts: boolean;
}

interface PaymentState {
  onSiteError: boolean;
}

export class Payment extends React.Component<PaymentProps, PaymentState> {

  constructor(props: PaymentProps) {
    super(props);
    this.state = {
      onSiteError: false
    };
  }

  reset() {
    setTimeout(() => {
      this.setState({ onSiteError: false });
    }, 2000);
  }

  async validateAndMoveView(bookingId: string, booking: mrCap.BookingRequest) {

    try {
      const postOrder = await api.postBooking(bookingId, booking);
      if (postOrder.ok) {
        this.props.setBookingOk(postOrder.ok);
        this.props.paymentSuccess();
      } else {
        this.setState({ onSiteError: true });
        this.reset();
      }
    } catch (err) {
      this.setState({ onSiteError: true });
      this.reset();
    }
  };

  render() {

    return (
      <div className={className('payment-target-content', { 'clean-window': this.props.financing })}>
        {this.props.financing ? <>
          <EcsterPayCheckout
            onSuccess={this.props.paymentSuccess}
            bookingId={this.props.bookingId}
            config={this.props.ecsterConfig}
            onlyProducts={this.props.onlyProducts} />
        </>:<>
          <div className='payment-cms-content' dangerouslySetInnerHTML={{__html: this.props.paymentOnSiteText}}></div>
          <div className='payment-total-price'>
            {this.props.totalDiscountPrice
              ? <span>
                <strong>{formatNumber(this.props.totalDiscountPrice)}</strong>
                {' '}
                <del>{formatNumber(this.props.totalPrice)}</del> SEK</span>
              : <span><strong>{formatNumber(this.props.totalPrice)}</strong> SEK</span>}
          </div>

          <div className='cta-btn primary'
            onClick={() => this.validateAndMoveView(this.props.bookingId, this.props.booking)}>Skicka bokningsförfrågan</div>
          <div className={`inline-error ${this.state.onSiteError ? 'visible' : ''}`}>
            <span>Fyll i alla obligatoriska fält för att fortsätta.</span>
          </div>
        </>}
      </div>
    );
  }
}